const adminRoutes = {
  users: '/user-management',
  usersExport: '/user-management/export',
  apps: '/apps',
  companies: '/company-management',
  companyUsers: '/users',
  companyTenants: '/tenants',
  licensedApps: '/licensed-apps',
  settings: '/settings',
  suvs: '/manage-suvs',
  roles: '/roles',
  appCatalog: '/app-catalog',
  tutorials: '/tutorial-manager',
  build: '/build',
  packageManagement: '/access-policies',
  permissions: '/permissions',
  utils: '/utils',
};

export default adminRoutes;
